import React from 'react';
import { CssBaseline, Box, Container, Grid } from '@mui/material';
import Banner from '../Layout/Banner';
import AuthFormSection from './AuthFormSection';

function History() {
    const url = `${process.env.REACT_APP_STATIC_URL}/uploads/banner/banner_dangnhap.png`;
    const title = 'ĐĂNG NHẬP - ĐĂNG KÝ'
  return (  
    <Box>
      <CssBaseline />
      <Banner url={url} title={title}/>
      <AuthFormSection></AuthFormSection>
    </Box>
  );
}

export default History;